<!--
 * @Description: 机构注册之管理员登录页面
 * @Author: wanqian, laoliu
 * @Date: 2022-05-19 16:43:52
-->
<template>
   <div class="body-inst-reg">
     <div class="left-body">
        <div style="margin-top: 127px; width: 257px; height: 62px;" >
          <el-image class="inst-logo" :src="logoPath" fit="contain"></el-image>
          <div class="inst-reg-box">
            <div class="inst-reg-title">{{title}}</div>
            <div class="header-children-title">机构注册与信息登记</div>
          </div>
        </div>
       <img style="margin-top: 92px; width: 312px; height: 222px;" 
			 	src="../../assets/login/instreg/img-instreg-mainbody.png" alt=""/>
     </div>
     <div class="right-body">
       <mobile-login @loginSuccess="loginSuccess" />
     </div>
   </div>
</template>

<script>
import MobileLogin from './components/MobileLogin.vue'

export default {
  name: 'InstAdminReg',
  components: {
    'mobile-login': MobileLogin,
  },

  data() {
    return {
      logoPath: '',
      title: '',
    }
  },

  methods:{
    loginSuccess() {
      this.$router.push({name: 'instregisterinfo'});
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (process.env.NODE_ENV == 'sdjk' || process.env.NODE_ENV == 'sdjktest') {
        this.title = '悠心陪护';
        this.logoPath = require('@/assets/login/icon-login-sdjklogo.png');
      } else {
        this.title = '星护云';
        this.logoPath = require('@/assets/login/icon-login-jtyhlogo.png');
      }
    });
  },
}
</script>

<style scoped>
.body-inst-reg {
  margin: 0;
  width: 100%;
  text-align: left;
  border: solid 0px;
  display: flex;
  flex-direction: row;
}
.left-body {
  width: 372px;
  background-color: #F0F7FC;
  min-height: 768px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.right-body {
  flex: 1;
}
.inst-logo {
  vertical-align: top;
  margin-right: 10px;
  width: 47px;
  height: 47px;
}
.inst-reg-box {
  display: inline-block;
  font-size: 18px;
}
.inst-reg-title {
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/login/InstAdminReg.vue